import React from "react";
import { LogoHeader } from "../../Components/Inicio/LogoHeaderComponent";
import { NavDesktop } from "../../Components/Inicio/NavDesktop";
import { NavMobile } from "../../Components/Inicio/NavMobile";
import { Footer } from "../../Components/Footer/FooterComponent";
import { EditarPerfilComponent } from "../../Components/Usuarios/EditarPerfilComponent";

export const EditarProfilePage = (props) => {
    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n} />
            <NavMobile I18n={props.I18n} />
            <EditarPerfilComponent I18n={props.I18n} user={props.User} />
            <Footer I18n={props.I18n} />
        </>
    );
};
